import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles({
  root: {
    width: "100%",
    position: "relative",
    paddingLeft: "12px",
    paddingRight: "20px",
    overflow: "hidden",
  },
});

const ProgressBar = (props) => {
  const classes = useStyles();
  const { progress } = props;
  return (
    <div className={classes.root}>
      <StyledProgressBar variant="determinate" value={progress} />
    </div>
  );
};

export default ProgressBar;

export const StyledProgressBar = withStyles((theme) => ({
  root: {
    height: 20,
    borderRadius: 8,
  },
  colorPrimary: {
    backgroundColor: "rgba(122,91,113, 1)",
  },
  bar: {
    borderRadius: 8,
    backgroundColor: "rgba(214,61,77, 1)",
  },
}))(LinearProgress);
